/**
 * Possible states for button after stopping spinner
 */
export type SpinnerState = 'success' | 'error' | 'reset';

/**
 * Spinner state constants
 */
export const SPINNER_STATE = {
  SUCCESS: 'success' as SpinnerState,
  ERROR: 'error' as SpinnerState,
  RESET: 'reset' as SpinnerState
} as const;

/**
 * Button state interface
 */
export interface ButtonState {
  loading: boolean;
  success?: boolean;
  error?: boolean;
}